import React, { useState } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import axios from 'axios';
import { useAuth } from './AuthProvider';

function RegisterModal({ show, handleClose, className }) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errors, setErrors] = useState({
        email: [],
        password: [],
        confirmPassword: [],
        general: ''
    });
    const { login } = useAuth();

    const handleRegister = async (e) => {
        e.preventDefault();
        setErrors({ email: [], password: [], confirmPassword: [], general: '' }); // Reset errors

        if (password !== confirmPassword) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                confirmPassword: ['Passwords do not match']
            }));
            return;
        }

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/register`, { email, password });
            login(response.data.user, response.data.token); // Update the user state and token
            handleClose();
            // Optionally, reset form fields after successful registration
            setEmail('');
            setPassword('');
            setConfirmPassword('');
        } catch (error) {
            console.error('Register failed', error);
            if (error.response && Array.isArray(error.response.data)) {
                const backendErrors = {
                    email: [],
                    password: [],
                    confirmPassword: [],
                    general: ''
                };

                error.response.data.forEach((err) => {
                    if (err.code === 'DuplicateUserName') {
                        backendErrors.email.push(err.description);
                    } else if (err.code.startsWith('Password')) {
                        backendErrors.password.push(err.description);
                    } else {
                        backendErrors.general += `${err.description} `;
                    }
                });

                setErrors(backendErrors);
            } else {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    general: 'Registration failed. Please try again.'
                }));
            }
        }
    };

    const handleGoogleLogin = () => {
        window.location.href = `${process.env.REACT_APP_API_BASE_URL}/auth/google`;
    };

    return (
        <Modal show={show} onHide={handleClose} className={className}>
            <Modal.Header closeButton>
                <Modal.Title>Register</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {errors.general && <Alert variant="danger">{errors.general}</Alert>}
                <Form onSubmit={handleRegister}>
                    <Form.Group controlId="formBasicEmail" className="mb-3">
                        <Form.Label>Email address</Form.Label>
                        <Form.Control
                            type="email"
                            placeholder="Enter email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            isInvalid={errors.email.length > 0}
                            required
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.email.map((msg, idx) => (
                                <div key={idx}>{msg}</div>
                            ))}
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group controlId="formBasicPassword" className="mb-3">
                        <Form.Label>Password</Form.Label>
                        <Form.Control
                            type="password"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            isInvalid={errors.password.length > 0}
                            required
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.password.map((msg, idx) => (
                                <div key={idx}>{msg}</div>
                            ))}
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group controlId="formBasicConfirmPassword" className="mb-3">
                        <Form.Label>Confirm Password</Form.Label>
                        <Form.Control
                            type="password"
                            placeholder="Confirm Password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            isInvalid={errors.confirmPassword.length > 0}
                            required
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.confirmPassword.map((msg, idx) => (
                                <div key={idx}>{msg}</div>
                            ))}
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Button variant="primary" type="submit" className="mt-2">
                        Register
                    </Button>

                    <Button onClick={handleGoogleLogin} variant="danger" className="mt-2 ms-2">
                        Register with Google
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
}

export default RegisterModal;

